const addEmployeeKeys = [
    { key: "UserName", alias: "Username", type: "string", required: true },
    { key: "FirstName", alias: "First name", type: "string", required: true },
    { key: "LastName", alias: "Last name", type: "string", required: true },
    { key: "MiddleName", alias: "Middle initial", type: "string", required: false },
    { key: "EmployeeNumber", alias: "Employee number", type: "string", required: true },
    { key: "HomeProfitCenterId", alias: "Home profit center", type: "number", required: true },
    { key: "SupervisorId", alias: "Supervisor", type: "number", required: true },
    { key: "PayType", alias: "Pay type", type: "string", required: true },
    { key: "PtoPlanId", alias: "PTO plan", type: "number", required: true },
    { key: "PayRate", alias: "Pay rate", type: "string", required: true },
    { key: "HireDate", alias: "Hire Date", type: "string", required: true }

]
export default addEmployeeKeys